import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeaturesFocus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2942_40852",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 56,
			height: 56,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 56,
				height: 56,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_2942_40852)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 22,
					cy: 34,
					r: 22,
					fill: "url(#paint0_linear_2942_40852)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 34,
					cy: 22,
					r: 22,
					fill: "url(#paint1_linear_2942_40852)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22 12C34.1503 12 44 21.8497 44 34C44 36.9581 43.4142 39.779 42.3555 42.3555C39.779 43.4142 36.9581 44 34 44C21.8497 44 12 34.1503 12 22C12 19.0417 12.5847 16.2201 13.6436 13.6436C16.2201 12.5847 19.0417 12 22 12Z",
					fill: "#1D172C"
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_d_2942_40852)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M28 34.5V21.5M33 26.5L28 21.5L23 26.5",
						stroke: "#7FE718",
						strokeWidth: 2,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_2942_40852",
				x: 18,
				y: 16.5,
				width: 20,
				height: 23,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.498039 0 0 0 0 0.905882 0 0 0 0 0.0941176 0 0 0 0.4 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2942_40852"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2942_40852",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2942_40852",
				x1: 37.5,
				y1: 18.5,
				x2: 6.5,
				y2: 49.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#DFCBF5",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DFCBF5",
					stopOpacity: .05
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2942_40852",
				x1: 49.5,
				y1: 6.5,
				x2: 18.5,
				y2: 37.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#DFCBF5",
					stopOpacity: .05
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DFCBF5",
					stopOpacity: .4
				})]
			})
		] })
	]
});
export default SvgFeaturesFocus;
